import React from 'react';
import { Chip } from '@mui/material';
import { helper } from '../../../utils/helper';

/**
 * Badge de statut d'un conteneur (workflow lavage).
 *
 * `status` est un entier renvoyé par l'API :
 *   0 = DONE (Lavé), 1 = TODO (Pas encore lavé),
 *   2 = PROBLEME (Problème remonté), 3 = INACCESSIBLE (Lavage impossible).
 *
 * Couleur + libellé centralisés via `helper.getColorForStatus` /
 * `helper.getConteneurStatusName` afin de rester cohérent avec
 * `PatrimoineDetailList` et les autres écrans.
 *
 * Props :
 *  - status : code numérique
 *  - size : taille du Chip (par défaut "small")
 *  - sx : surcharges éventuelles
 */
function ConteneurStatusBadge({ status, size = 'small', sx, ...rest }) {
    return (
        <Chip
            size={size}
            label={helper.getConteneurStatusName(status)}
            sx={{ ...helper.getColorForStatus(status), fontWeight: 500, ...sx }}
            {...rest}
        />
    );
}

export default ConteneurStatusBadge;
